// extracted by mini-css-extract-plugin
export default {"controlGrid":"AddAnnouncement_controlGrid__HKVTM","icon":"AddAnnouncement_icon__YaZar","labelText":"AddAnnouncement_labelText__McQ8K"};